module.exports = __webpack_public_path__ + "img/style_3_2.177c1a77.png";